import { useStaticQuery, graphql } from "gatsby"

export const useMegaMenuButtonsQuery = () => {
    const { firstButton, secondButton } = useStaticQuery(
        graphql`
        query MegaMenuButtonsQuery {
          firstButton: wp {
            acfOptionsCommonItems {
              commonItems {
                commonItemsButtonText
              }
            }
          }
          secondButton: wpPage(title: {eq: "Home"}) {
            herovideo {
              heroVideoButton {
                title
                url
              }
            }
          }
        }
        `)
return {firstButton, secondButton}
}